<template>
  <UContainer>
    <PageSearchFilter
      v-model:directions="selectedDirections"
      v-model:query="query"
      class="mb-10"
      @search="search"
    />

    <ExpandableList v-slot="{ displayItems }" :items="directions" :limit="9">
      <CommonGridCards :items="displayItems" :pending="pending">
        <template #card="{ item }">
          <CommonCard
            :item="item"
            :to="`/directions/${item.id}`"
            :description-under-left="descriptionUnder"
            :ui="{
              title: 'max-sm:line-clamp-1',
            }"
          >
          </CommonCard>
        </template>
      </CommonGridCards>
    </ExpandableList>
  </UContainer>
</template>

<script lang="ts" setup>
import ExpandableList from '~/components/ExpandableList.vue'
import type { DirectionMenuItem, IconWithLabel, SearchParams } from '~/types'

defineOptions({
  name: 'SchoolDetailDirections',
})

const route = useRoute()
const directoryStore = useDirectoryStore()
const { directions } = storeToRefs(directoryStore)

const { untilReady } = useRegionReady()

const { pending } = await useAppAsyncData(
  `school-directions-${route.params.id}`,
  async () => {
    await untilReady()
    await directoryStore.fetchDirections()
  },
)

const selectedDirections = ref<DirectionMenuItem[]>([])
const query = ref('')

const descriptionUnder: IconWithLabel[] = [
  {
    icon: 'i-local-graduation-cap',
    label: 'Школы: ',
    value: '44 мок',
    iconClass: '',
  },
  {
    icon: 'i-local-award',
    label: 'Тренеры: ',
    value: '24 мок',
    iconClass: 'bg-warning-light',
  },
]

const search = async (query?: SearchParams) => {
  await directoryStore.fetchDirections(query)
}
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 422px;
  --card-image-height: 240px;

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 160px;
  }
}
</style>
